import { useQuery } from "@tanstack/react-query";
import { API_ROUTES } from "../../constants";
import { apiClient } from "./apiClient";
import { QUERY_KEYS } from "./constants";

interface ChatTitleResponse {
  title: string;
}

/**
 * Hook to fetch chat title for a specific chat session
 */
export const useGetChatTitle = (chatId: string | null) => {
  return useQuery<ChatTitleResponse>({
    queryKey: [QUERY_KEYS.getChatTitle, chatId],
    queryFn: async () => {
      if (!chatId) {
        throw new Error("Chat ID is required");
      }

      const response = await apiClient.get(
        API_ROUTES.omniSearch.chatTitle(chatId)
      );
      return response.data as ChatTitleResponse;
    },
    enabled: !!chatId, // Only run query if chatId exists
    staleTime: 1000 * 60 * 5, // Consider data fresh for 5 minutes
    retry: 2,
  });
};
